'use client'
import type { WritableAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import type { ReactNode } from 'react'

type AtomsHydratorProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    atomValues: Iterable<readonly [WritableAtom<unknown, [any], unknown>, unknown]>
    children: ReactNode
}

function AtomsHydrator({ atomValues, children }: AtomsHydratorProps): ReactNode {
    useHydrateAtoms(new Map(atomValues))
    return children
}

export { AtomsHydrator }
